import { Injectable, ChangeDetectorRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CdRefreshService {
    private cdr: ChangeDetectorRef | null = null;

    register(cdr: ChangeDetectorRef): void {
        this.cdr = cdr;
    }

    markForCheck(): void {
        this.cdr?.markForCheck();
    }
}
